import { FC, memo } from 'react'

const DataDisclosures: FC = () => {
  return (
    <>
      <h6>Data Disclosure</h6>
      <p>
        Bankrate utilizes data from our{' '}
        <a href="https://www.bankrate.com/mortgages/mortgage-calculator/">
          mortgage calculator
        </a>{' '}
        and market data provided by Redfin, as reported in its{' '}
        <a
          rel="nofollow"
          href="https://www.redfin.com/news/data-center/"
          target="_blank"
        >
          data center
        </a>
        , to analyze median home values, home availability, homes sold, days on
        market, estimated monthly payments and the cost to buy and sell a house
        in each area. The Redfin data in our article is automatically updated
        monthly, typically during the third week of each month, with the prior
        month’s data (e.g., January data will appear in late February).
      </p>
    </>
  )
}

export default memo(DataDisclosures)
